import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { IndicadoresPgService } from '../../services/indicadores-pg.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-detalhe-pg-indicadores-somatorio-edit',
  templateUrl: './detalhe-pg-indicadores-somatorio-edit.component.html',
  styleUrls: ['./detalhe-pg-indicadores-somatorio-edit.component.scss']
})
export class DetalhePgIndicadoresSomatorioEditComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit {

  type: string = '';

  constructor(
    private myService: IndicadoresPgService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.type = this.activatedRoute.snapshot.data['type'];
    this.entity.summed.forEach(indicador => {
      if (indicador?.value?.length && this.entity?.checkedSummed?.length) {
        indicador.value.forEach((item) => {
          item.check = this.entity?.checkedSummed.includes(item.id);
        });

        const allItemsChecked = indicador.value.every(item => item?.check);
        if (allItemsChecked) {
          indicador.check = true;
        }
      }
    });

    this.loaded();
  }

  selectAll(event: boolean, summed) {
    summed.check = event;
    this.entity.summed.forEach(indicador => {
      if (indicador?.value?.length) {
        indicador.value.forEach((item) => {
          if (summed.name == indicador.name) {
            item.check = event;
          }
        })
      }
    });
  }

  changeselectAll() {
    this.entity.summed.forEach(indicador => {
      if (indicador?.value?.length) {
        indicador.check = indicador.value.every(item => item?.check);
      }
    });
  }

  getDataCreate() {
    const listChecked = this.entity.summed
      .flatMap(indicador => indicador?.value ? indicador.value : [])
      .filter(item => item.check)
      .map(item => item.id);

    return {
      pf_ind_sum: {
        ind_id: listChecked,
      },
    };
  }

  salvar(): void {
    this.loading();
    if (this.entity?.id) {
      this.addSub(
        this.myService.updateSomados(this.getDataCreate(), this.entity?.id).subscribe({
          next: (res) => {
            this.msgSuccess('Indicadores Somandos alterados com sucesso!')
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    }
  }

  voltar() {
    this.navigation.back(['projetos', this.type ?? 'agregador', 'indicadores', this.entity?.id]);
  }

}
